import "./AddBoostFactorModal.scss"
import React, { ReactElement, useState, useMemo } from "react"
import { PoolName } from "src/constants"
import { useGetBoostedFarms } from "src/hooks/BoostFarming/useFarmBoostContract"

import DrawerModalWrapper from "../DrawerModalWrapper"
import PoolInitView from "./PoolInitView"
import PoolSelectorView from "./PoolSelectorView"
import PoolRemoveView from "./PoolRemoveView"

enum Step {
  Init,
  Add,
  Remove,
}

interface Props {
  open: boolean
  onClose: () => void
}
export default function PoolSelectModal({
  open,
  onClose,
}: Props): ReactElement {
  const { data: boostedPoolIds } = useGetBoostedFarms()
  const [selectedPoolIds, setSelectedPoolIds] = useState<number[]>([])
  const [step, setStep] = useState<Step>(Step.Init)
  const [removePool, setRemovePool] = useState<PoolName>()

  const onCloseModal = () => {
    setSelectedPoolIds([])
    setStep(Step.Init)
    onClose()
  }

  const title = useMemo(() => {
    switch (step) {
      case Step.Add:
        return "Select Pool to Boost"
      case Step.Remove:
        return "Remove Pool Boost"
      case Step.Init:
      default:
        return "Select Boosted Pool"
    }
  }, [step])

  return (
    <DrawerModalWrapper title={title} open={open} onClose={onCloseModal}>
      {step === Step.Init && (
        <PoolInitView
          boostedPoolIds={boostedPoolIds}
          onAdd={() => {
            setStep(Step.Add)
          }}
          onRemove={(pool) => {
            setRemovePool(pool)
            setStep(Step.Remove)
          }}
        />
      )}
      {step === Step.Add && (
        <PoolSelectorView
          boostedPoolIds={boostedPoolIds}
          selectedPoolIds={selectedPoolIds}
          onChange={(selectedPools) => {
            setSelectedPoolIds(selectedPools.map((pool) => pool.pid))
          }}
          onClose={onCloseModal}
        />
      )}
      {step === Step.Remove && removePool && (
        <PoolRemoveView poolName={removePool} onClose={onCloseModal} />
      )}
    </DrawerModalWrapper>
  )
}
